import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'

export default function Loader(props) {
	return <div className="loader">
		<FontAwesomeIcon icon={fa.faSpinner} spin/>
	</div>;
}
